module.exports = __webpack_public_path__ + "img/export.23090ca6.svg";